/* eslint-disable prettier/prettier */
import Splide from "@splidejs/splide";
import "@splidejs/splide/css";

const arrowPath = "M29.5,19.2L14.6,4.2c-0.3-0.3-0.8-0.5-1.3-0.5c-0.5,0-1,0.2-1.3,0.5l-1.1,1.1c-0.7,0.7-0.7,1.9,0,2.6l12.6,12.6L10.9,33c-0.3,0.3-0.5,0.8-0.5,1.3s0.2,1,0.5,1.3l1.1,1.1c0.3,0.3,0.8,0.5,1.3,0.5s1-0.2,1.3-0.5l15-15c0.3-0.3,0.5-0.8,0.5-1.3C30.1,20,29.9,19.5,29.5,19.2L29.5,19.2z";

const options = {
  type: "slide",
  perPage: 2,
  //gap: 20,
  arrowPath: arrowPath,
  arrows: false,
  pagination: true,
  drag: true,

  gap: 80,
  trimSpace: false,
  padding: {
    //left : '4rem',
    right: "9rem",
  },
  mediaQuery: "max",
  breakpoints: {
    1600: {
      perPage: 2,
    },
    768: {
      perPage: 1,
      gap: 20,
      padding: {
        right: "4rem",
      },
    },
  },
};
const homeSlider = document.querySelector(".home_slider");
const homeCategorySlide = document.querySelector(".home_category_slide");
const productPreviewSlide = document.querySelectorAll(".product_preview_slide");
const homeNewsSlide = document.querySelector(".home_news_slide");
const productImgSlide = document.querySelector(".product_img_slide");
const categoryMenu = document.querySelector(".home_category_menu");
const workImgSlide = document.querySelector(".work_img_slide");
const serviceSlide = document.querySelector(".serviceSlide");

export default class Slider {
  static productPreviewSlide(target) {
    target.forEach((gallery) => {
      // Leggi il valore di data-per-page (attento, è una stringa)
      const perPage = parseInt(gallery.getAttribute("data-per-page")) || 2;
      options.perPage = perPage;
      new Splide(gallery, {
        arrowPath: arrowPath,
        type: "slide", // oppure 'loop'
        perPage: perPage, // 3 elementi per slide
        perMove: 1,
        gap: "1.5rem", // spazio uguale tra gli elementi
        pagination: false,
        arrows: true,
        breakpoints: {
          1024: {
            perPage: 2,
          },
          640: {
            perPage: 2,
          },
          480: {
            perPage: 1,
            gap: "1rem",
            padding: {
              right: "6em",
            },
          },
        },
      }).mount();
    });
  }

  /* gallery ONLY mobile */
  static categoryMenu(target) {
    let splide = new Splide(target, {
      arrowPath: arrowPath,
      destroy: true,
      type: "slide", // oppure 'loop'
      perPage: 4, // 3 elementi per slide
      perMove: 1,
      gap: "1.5rem", // spazio uguale tra gli elementi
      pagination: true,
      arrows: false,
      breakpoints: {
        1024: {
          destroy: false,
          perPage: 4,
        },
        640: {
          perPage: 2,
        },
      },
    });
    splide.mount();
  }

  static homeSlider(target) {
    let splide = new Splide(target, {
      arrowPath: arrowPath,
      type: "slide", // oppure 'loop'
      perPage: 1,
      perMove: 1,
      arrows: true,
    });
    splide.mount();
  }

  static homeCategorySlider(target) {
    const perPage = parseInt(target.getAttribute("data-per-page")) || 2;
    options.perPage = perPage;
    let splide = new Splide(target, {
      arrowPath: arrowPath,
      type: "slide", // oppure 'loop'
      perPage: 4, // 3 elementi per slide
      perMove: 1,
      gap: "1.5rem", // spazio uguale tra gli elementi
      pagination: true,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        640: {
          perPage: 1,
          gap: "0",
        },
        480: {
          perPage: 1,
          gap: "2rem",
          padding: {
            right: "6em",
          },
        },
      },
    });
    splide.mount();
  }

  //gallery home page newss
  static homeNewsSlide(target) {
    const perPage = parseInt(target.getAttribute("data-per-page")) || 3;
    options.perPage = perPage;
    let splide = new Splide(target, {
      type: "slide", // oppure 'loop'
      perPage: 3, // 3 elementi per slide
      arrowPath: arrowPath,
      perMove: 1,
      gap: "1.5rem", // spazio uguale tra gli elementi
      pagination: false,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        640: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }

  //gallery Pagina Prodotto
  static productImgSlide(target) {
    //main carousel
    let splide = new Splide(target, {
      type: "slide", // oppure 'loop'
      perPage: 1, // 3 elementi per slide
      pagination: false,
      arrowPath: arrowPath,
      arrows: false,
      breakpoints: {
        1024: {
          perPage: 1,
        },
        640: {
          perPage: 1,
        },
      },
    });

    //thumb carousel
    let thumb = new Splide("#product-thumbnail", {
      fixedHeight: 80,
      perPage: 4,
      gap: 10,
      rewind: true,
      pagination: false,
      isNavigation: true,
      direction: "ttb",
      arrowPath: arrowPath,
      //paginationDirection: "ttb",
      focus: 0,
      //heightRatio: 1,
      height: "auto",
      breakpoints: {
        768: {
          direction: "ltr", // mobile orizzontale
          fixedHeight: null,
          height: "auto",
          perPage: 4,
        },
        480: {
          perPage: 4,
        },
      },
    });
    splide.sync(thumb);
    splide.mount();
    thumb.mount();

    Slider.setImageGallery(splide);
    //Gestione del click
  }

  static setImageGallery(splide) {
    const varElements = document.querySelectorAll(".single-variant");

    varElements.forEach((variant) => {
      variant.addEventListener("click", (e) => {
        e.preventDefault();

        const slides = splide.Components.Slides.get();
        const target = slides.find((slide) => {
          return slide.slide.dataset.varname === variant.dataset.varcode;
        });

        if (target) {
          splide.go(target.index);
        }
      });
    });
  }

  //work Pagina Prodotto
  static workImgSlide(target) {
    //main carousel
    let splide = new Splide(target, {
      type: "slide", // oppure 'loop'
      perPage: 4, // 3 elementi per slide
      arrowPath: arrowPath,
      perMove: 1,
      gap: "1.5rem", // spazio uguale tra gli elementi
      pagination: false,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 4,
        },
        768: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }

  //Servizi Gallery solo mobile
  static serviceSlide(target) {
    //main carousel
    let splide = new Splide(target, {
      destroy: true,
      type: "slide", // oppure 'loop'
      perPage: 1, // 3 elementi per slide
      arrowPath: arrowPath,
      perMove: 1,
      gap: "1.5rem", // spazio uguale tra gli elementi
      pagination: false,
      arrows: true,
      breakpoints: {
        980: {
          destroy: false,
          perPage: 1,
        },
      },
    });
    splide.mount();
  }

  static init() {
    if (productPreviewSlide) {
      Slider.productPreviewSlide(productPreviewSlide);
    }
    if (homeCategorySlide) {
      Slider.homeCategorySlider(homeCategorySlide);
    }
    if (homeSlider) {
      Slider.homeSlider(homeSlider);
    }
    if (homeNewsSlide) {
      Slider.homeNewsSlide(homeNewsSlide);
    }
    if (productImgSlide) {
      Slider.productImgSlide(productImgSlide);
    }
    if (categoryMenu) {
      Slider.categoryMenu(categoryMenu);
    }
    if (workImgSlide) {
      Slider.workImgSlide(workImgSlide);
    }
    if (serviceSlide) {
      Slider.serviceSlide(serviceSlide);
    }
  }
} //fine classe
